import { IOpsLinkTopic } from "@vmosolutions/oc-interfaces";

/**
 * Whether users may compose free text on an OpsLink topic. Topics that are not
 * humanWriteable carry machine-generated messages (e.g. EFB movement messages with
 * a data payload OC acts on), so the UI must not offer a way to post or reply on
 * them. A bare topic id (unpopulated) is treated as not writeable.
 */
export const isHumanWriteableTopic = (topic?: IOpsLinkTopic | string | null): topic is IOpsLinkTopic =>
  typeof topic === "object" && topic?.humanWriteable === true;
